import React, {MouseEvent} from "react";
import {createPortal} from "react-dom";
import ContentBox from "../content-box/ContentBox";
import CommonProps from "../CommonProps";
import './Modal.scss';

interface ModalProps extends CommonProps {
    isOpen: boolean;
    onClose: () => void;
}

const Modal = (props: ModalProps) => {

    if (!props.isOpen) return null;

    const handleOverlayClick = (e: MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            props.onClose();
        }
    };

    const modalContent = (
        <div className="modal-overlay"
             onClick={handleOverlayClick}>
            <ContentBox className={`modal-content ${props.className ? props.className : ''}`}
                        data-testid="modal"
                        aria-label="modal"
            >
                <>
                    <div className="modal-close-button">
                        <button onClick={props.onClose}>&times;</button>
                    </div>
                    <div className="modal-scrollable-content">
                        {props.children}
                    </div>
                </>
            </ContentBox>
        </div>
    );

    return createPortal(modalContent, document.body);
};

export default Modal;
